import { t } from 'i18next';
import { AutocompleteProps, SelectFieldProps } from '../types';

export function getSelectPassdownProps<T>(props: SelectFieldProps<T> | AutocompleteProps<T>) {
  return {
    items: props.items && [
      ...(props.emptyOption
        ? [
            {
              title: typeof props.emptyOption === 'boolean' ? t('All') : props.emptyOption,
              value: null,
            },
          ]
        : []),
      ...props.items,
    ],
    modelValue: props.emptyOption && props.modelValue === undefined ? null : props.modelValue,
    emptyOption: undefined,
  };
}

export function getSelectionValue<T>(
  value: any,
  props: SelectFieldProps<T> | AutocompleteProps<T>,
) {
  const isUndefined =
    (props.emptyOption && value === null) ||
    (props.emptyAsUndefined && (!value || Object.keys(value).length === 0));
  return isUndefined ? undefined : value;
}
